<template>
  <div v-if="showMultipleMatch" style="background-color: #FFF1D9;;">
    <div class="row m-0 d-flex justify-content-center mb-3">
      <div class="col-10 explaination mt-2 ">
        {{ lang }}{{ translation.chooseImageThenDefinition }}
      </div>
    </div>
    <div class="match-grid mb-2">
      <template v-for="(image, index) in imagesArray" :key="index">
        <div class="match-img-wrapper" @click="selectImage(index, $event)">
          <img :src="image.src" alt="image" />
        </div>
        <div class="descriptionItem" @click="checkSelection(shuffledItems[index], $event)">
          <div class="itemTitle mb-1" style="pointer-events: none">{{ shuffledItems[index].title }}</div>
          {{ shuffledItems[index].description }}
        </div>
      </template>
    </div>
    <div v-if="completed" class="over">
      <div class="myModal">
        <img src="../../static/img/correctAnswer.gif" alt="" id="like"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showMultipleMatch: {
      type: Boolean,
      default: false
    },
    points: {
      type: Object,
      default: () => ({})
    },
    pointsArrayOrder: {
      type: Array,
      default: () => []
    },
    pointNum: {
      type: Number,
      default: 0
    }
  },
  emits: ['error-increment', 'error-decrement', 'quiz-completed'],
  data() {
    return {
      completed: false,
      selectedImageIndex: null,
      selectedImageEl: null,
      selectedDescIndex: null,
      selectedDescEl: null,
      translation: {},
      imagesArray: [
        {
          src: require("../../static/img/bague.jpeg"),
          index: 4,
        },
        {
          src: require("../../static/img/bol.jpeg"),
          index: 2,
        },
        {
          src: require("../../static/img/bouteille1.jpeg"),
          index: 1,
        },
        {
          src: require("../../static/img/tsafrat.jpeg"),
          index: 3,
        },
        {
          src: require("../../static/img/gdera.jpeg"),
          index: 5,
        },
      ]
    };
  },
  computed: {
    lang() {
      return this.translate(this.$store.getters.lang);
    },
    shuffledItems() {
      return this.shuffleArray(this.descriptions);
    },
    currentPoint() {
      return Object.values(this.points)[
        this.pointsArrayOrder[this.pointNum] - 1
      ];
    },
    descriptions() {
      var descriptionsArray = [
        {
          title: "צפחת", description: "כלי עשוי חרס בצורת עדשה. שימש לנוזלים בדומה למימיה",
          index: 1,
        },
        {
          title: "קובעת", description: "קערת חרס העומדת על רגל גבוהה - מתגלה בדרך כלל בקברים או במקדשים",
          index: 3,
        },
        {
          title: "קדרה", description: " כלי קיבול ואחסון לגרעינים וקמח",
          index: 5,
        },
        {
          title: "טבעת עם עיטור חרפושית", description: "טבעת ששימשה כחותם",
          index: 4,
        },
        {
          title: "קערת חרס", description: "",
          index: 2,
        },
      ];
      return descriptionsArray;
    },
  },
  methods: {
    selectImage(index, event) {
      const wrapper = event.currentTarget;
      if (wrapper.classList.contains('greenBorder')) return;
      if (this.selectedImageEl) {
        this.selectedImageEl.classList.remove('yellowBorder');
      }
      wrapper.classList.add('yellowBorder');
      this.selectedImageEl = wrapper;
      this.selectedImageIndex = this.imagesArray[index].index;
      if (this.selectedDescEl) {
        this.checkMatch();
      }
    },
    checkSelection(item, event) {
      const descEl = event.currentTarget;
      if (descEl.classList.contains('greenBorder')) return;
      if (this.selectedDescEl) {
        this.selectedDescEl.classList.remove('yellowBorder');
      }
      descEl.classList.add('yellowBorder');
      this.selectedDescEl = descEl;
      this.selectedDescIndex = item.index;
      if (this.selectedImageEl) {
        this.checkMatch();
      }
    },
    checkMatch() {
      const imgEl = this.selectedImageEl;
      const descEl = this.selectedDescEl;
      if (this.selectedImageIndex === this.selectedDescIndex) {
        this.$emit('error-increment');
        imgEl.classList.remove('yellowBorder');
        imgEl.classList.add('greenBorder');
        descEl.classList.remove('yellowBorder');
        descEl.classList.add('greenBorder');
        this.selectedImageEl = null;
        this.selectedImageIndex = null;
        this.selectedDescEl = null;
        this.selectedDescIndex = null;
        const countGreenBorder = document.getElementsByClassName('greenBorder').length;
        if (countGreenBorder / 2 === this.descriptions.length) {
          setTimeout(() => {
            this.completed = true;
            setTimeout(() => { this.$emit('quiz-completed'); }, 2000);
          }, 200);
        }
      } else {
        this.$emit('error-decrement');
        imgEl.classList.remove('yellowBorder');
        imgEl.classList.add('redBorder');
        descEl.classList.remove('yellowBorder');
        descEl.classList.add('redBorder');
        this.selectedImageEl = null;
        this.selectedImageIndex = null;
        this.selectedDescEl = null;
        this.selectedDescIndex = null;
        setTimeout(() => {
          imgEl.classList.remove('redBorder');
          descEl.classList.remove('redBorder');
        }, 1000);
      }
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    translate(lang) {
      switch (lang) {
        case "ar":
          this.translation = {
            chooseImageThenDefinition: "عليكم مطابقة الصورة مع الكلمة المناسبة.",
          };
          break;
        case "en":
          this.translation = {
            chooseImageThenDefinition: "Fermer",
          };
          break;
        case "he":
          this.translation = {
            chooseImageThenDefinition: "התאימו בין התמונה למילה המתאימה לה",
          };
          break;
        default:
      }
    },
  },
};
</script>

<style>
.itemTitle {
  font-size: 20px;
  font-weight: bold;
  text-align: center !important;
}

.explaination {
  text-align: center;
  font-family: "Assistant", sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: black;
  border: solid grey 1px;
  background: white;
  padding: 11px;
  border-radius: 10px;
}

.myModal {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #71A83F;
  border-radius: 100%;
  width: 220px;
}

#like {
  height: 200px;
  border-radius: 100%;
}

.over {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
}

.greenBorder {
  border: solid rgb(5, 253, 5) 6px !important;
}

.redBorder {
  border: solid rgb(253, 13, 13) 6px !important;
}

.yellowBorder {
  border: solid yellow 6px !important;
}

/* Grid layout — each row is one image + one description, guaranteed aligned */
.match-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 17px 8px;
  padding: 0 8px;
}

.match-img-wrapper {
  height: 138px;
  overflow: hidden;
  border: solid white 6px;
  border-radius: 10px;
  box-sizing: border-box;
  cursor: pointer;
}

.match-img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.descriptionItem {
  display: flex;
  height: 138px;
  overflow: hidden;
  border: 6px solid transparent;
  box-sizing: border-box;
  text-align: right;
  padding: 10px;
  justify-content: center;
  font-size: 16px;
  background: white;
  border-radius: 10px;
  flex-wrap: wrap;
  align-content: center;
  color: #71A83F;
  cursor: pointer;
}
</style>
